import { Inject, Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '.';
import { throwError } from 'rxjs';

//export const LOGIN_LABEL = 
@Injectable({
  providedIn: 'root'
})
export class HomeService {
  isActivated = false;
  response: any;
  fileref: any;
  institutionId: number;
  shortName: any;
  i18n: any;
  private loadSpinner = new BehaviorSubject(false);
  landingLoad = this.loadSpinner.asObservable();
  userpk: string;
  instshortname: string;
  cssPathUrl = new Subject();
  chatbotCssUrl=new Subject();
  chatBotPluginScript= new Subject();
  sendMessage(message: boolean) {
    this.loadSpinner.next(message);
  }

  openChat = new Subject();
  closeChat = new Subject();
  endChat = new Subject();
  openCreateCaseModal = new Subject();

  private gaAccountID = new Subject();
  private gaDomainName = new Subject();
  private ga4AccountID = new Subject();
  gaAccountIDValue = this.gaAccountID.asObservable();
  gaDomainNameValue = this.gaDomainName.asObservable();
  ga4AccountIDValue = this.ga4AccountID.asObservable();
  sendGAConfig(gaAccountIDValue: string, gaDomainNameValue: string, ga4AccountIDValue:string) {
    this.gaAccountID.next(gaAccountIDValue);
    this.gaDomainName.next(gaDomainNameValue);
    this.ga4AccountID.next(ga4AccountIDValue);
  }
  constructor(private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
    public session: SessionStorageService,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private router: Router) {
    
  }

async isactive(instshortname: string): Promise<boolean> {
    const isActiveStatus = await this.http.get(environment.shp_active_check + instshortname).toPromise()
      .then((user: any) => {
        this.instshortname = instshortname;
        this.response = user.return_body;
        this.institutionId = this.response.institution_Id;
        
        this.sendGAConfig(this.response.GA_Account, this.response.GA_DomainName, this.response.GA4_script);
        this.chatbotCssUrl.next(this.response.chatBot_CSS);
        this.chatBotPluginScript.next(this.response.chatBot_PluginScript);
        this.cssPathUrl.next(this.response.css_path);
        this.shortName = instshortname;
        this.fileref = document.createElement('link');
        this.fileref.setAttribute('rel', 'stylesheet');
        this.fileref.setAttribute('type', 'text/css');
        this.fileref.setAttribute('src', this.response.css_path);
        if (this.fileref !== 'undefined') {
          document.getElementsByTagName('head')[0].appendChild(this.fileref);
        }
        this.isActivated = this.response.shp_active;
        return this.isActivated;
      });
    await this.http.get(environment.i18n + this.response.locale).toPromise()
      .then((i18nData: any) => {
        this.i18n = i18nData;
        this.session.set('i18n', this.i18n.return_body);
      });
    return isActiveStatus;
  }

  getCurrentUrl(){
    return  this.router.url.split('/')[1];
  }
  getAllPageTitle(){
    return 'PageTitle' + window.location.pathname.split("/")[2];
    }

  setPageTitleValue(pageTitleObject){
    localStorage.setItem(this.getAllPageTitle(), JSON.stringify(pageTitleObject) );
  }

  getPageTitleValue(){
    return localStorage.getItem(this.getAllPageTitle());
    }

  removePageTitleVAlue(){
    localStorage.removeItem(this.getAllPageTitle());
  }

  setDynamicStyle(cssURL: string) {
    console.log("SET DYNAMIC STYLE CALLED!");
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('link');
    style.id = 'css-styling';
    style.rel = 'stylesheet';
    style.href = `${cssURL}`;
    head.appendChild(style);
  }
  setDynamicChatbotScript(scriptTag: string) {
    console.log("SET DYNAMIC CHATBOT SCRIPT CALLED!");
    const head = this.document.getElementsByTagName('body')[0];
    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.text = `${scriptTag}`;
    head.appendChild(script);
  }

  setDynamicChatbotStyle(styleUrl: string) {
    console.log("SET DYNAMIC CHATBOT STYLE CALLED!");
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('link');
    // script.type = 'text/javascript';
    style.rel = 'stylesheet';
    style.href = `${styleUrl}`;
    head.appendChild(style);
  }
    
  getInternationalization() {
    this.geti18N().subscribe(res => {
      this.i18n = res;
      this.session.set('i18n', this.i18n.return_body);
    });
  }

  geti18N() {
    return this.http.get(environment.i18n + this.response.locale);
  }

   getHeaderConfig(): Observable<any> {
if(this.isActivated){
  return this.http.get <Observable<any>>(environment.headerConfig + this.institutionId);
  }
    return this.http.get<Observable<any>>(environment.headerConfig + environment.default_dept_id);  
  }
  

isSHPActivated(): boolean {
    return this.isActivated;
  }
  getFooterConfig(): Observable<any> {
    if(this.isActivated){
      return this.http.get<Observable<any>>(environment.footerConfig + this.institutionId)  ;
    }
    return this.http.get<Observable<any>>(environment.footerConfig + environment.default_dept_id);
  }

  getTopArticles(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.topArticles);
  }

  getQuickLinks(): Observable<any> {
    return this.http.get(environment.quickLinks + this.institutionId);
  }

  getHelpTopics(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.guidedHelp);
  }

  getChildren(pk): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.getChildrenTopics + pk);
  }

  getSearchData(data): Observable<any> {
    return this.http.post(environment.api_vi + environment.autocomplete + this.institutionId, data);
  }

  getSearchResults(pagesize, startpage, data): Observable<any> {
    return this.http.post(environment.api_vi + this.institutionId + environment.searchresults + "?_pageSize_=" + pagesize + "&_startPage_=" + startpage, data);
  }

  getTokenValidity(): Observable<any> {
    let uri = "/api/v1/secureshp/testSecureApi"
    return this.http.get(uri);
  }

  getViewArticles(articleId): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.viewArticles + articleId);
  }

  getFeedback(kbopencounter_id, feedback_status): Observable<any> {
    return this.http.put(environment.api_vi + this.institutionId + environment.feedback + "?kbopencounter_id=" + kbopencounter_id + "&feedback_status=" + feedback_status, null);
  }
  getPasswordReset(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.pwdResetConfig);
  }
  getCaseFields(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.createCase + "?show_in_create=true&template_type=HELP_CENTER");
  }
  getLdapPasswordReset(data): Observable<any> {
    return this.http.post(environment.api_vi + "shp/" + this.institutionId + environment.ldapPwdResetConfig, data);
  }
  getPageTitle(): Observable<any> {
    let shortName = this.getCurrentUrl();
    if(shortName === undefined || shortName === null || shortName.length === 0 ){
      shortName = window.location.pathname.split("/")[2];
    }
    return this.http.get(environment.api_vi + "shp/"  + environment.headerTitle + shortName);
  }
  ModifyPasswordPost(data): Observable<any> {
    return this.http.post(environment.api_vi + "secureshp/shp/" + this.institutionId + environment.modifyPassword, data);
  }
  checkTokenExp(): Observable<any> {
    return this.http.delete("/api/v1/shp/config/checkTokenTime" );
  }


  postCaseFields(data): Observable<any> {
   console.log("needLogin ",data.needLogin);
   console.log("isUserLoggedIn ",this.authService.isUserLoggedIn());
    if((data.needLogin == true) && (!this.authService.isUserLoggedIn())){
      console.log("session error may have occured");
      this.navigateToLogin(this.router.url);
      return throwError('Case not created. Please login to create a Case.');
    }
    if (this.authService.isUserLoggedIn()) {
      return this.http.post(environment.api_vi + "secureshp/" + this.institutionId + environment.submitCase, data);
    } else {
      return this.http.post(environment.api_vi + this.institutionId + "/internal" + environment.submitCase, data);
    }
  }

  getCustomerConfig(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.customerConfig);
  }
  getDependencyTemplate(old_option_id, data): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.dependencyConfiguration + old_option_id + environment.dependencyTemplate, data);
  }
  getNewDependency(new_option_id): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.dependencyConfiguration + new_option_id + environment.dependencyTemplate);
  }
  getChatTimeOut(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.chat);
  }
  getShpLogin(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.shplogin);
  }
  postFileUploads(data): Observable<any> {
    return this.http.post(environment.api_vi + this.institutionId + environment.fileUpload, data);
  }
  getTicketConfigurationFields(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.ticketFields);
  }
  getHelpCenterConfiguration(): Observable<any> {
    return this.http.get(environment.api_vi + "secureshp/" + this.institutionId + environment.helpCenterFields);
  }
  getCaseConfiguration(): Observable<any> {
    this.userpk = this.authService.getCurrentUserPK();//localStorage.getItem('pk')
    return this.http.get(environment.api_vi + "secureshp/" + this.institutionId + environment.CaseFields + "?_userpk_=" + this.userpk);
  }

  getTopArticleTitle(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.topTenArticle);

  }

  getKbSearchConfiguration(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.kbSearchConfig);
  }

  getCase(case_id): Observable<any> {
    return this.http.get(environment.api_vi + "secureshp/" + this.institutionId + environment.viewCase + case_id);
  }
  postFields(case_id, action_id, data): Observable<any> {
    return this.http.post(environment.api_vi + "secureshp/" + this.institutionId + "/shp/case/" + case_id + "/action/" + action_id, data);
  }
  getGuidedHelp(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.gdHelp);
  }
  getAllSurveyFields(inst): Observable<any> {
   // return this.http.get(environment.api_vi + "secureshp/" + inst + '/shp/survey');
   return this.http.get(environment.api_vi  + inst + '/shp/survey');
  }
  getReferenceSurvey(referenceInst): Observable<any> {
   // return this.http.get(environment.api_vi + "secureshp/" + referenceInst + '/shp/survey');
   return this.http.get(environment.api_vi + referenceInst + '/shp/survey');
  }
  getSurveyFields(survey_id,inst): Observable<any> {
    //return this.http.get(environment.api_vi + "secureshp/" + this.institutionId + '/shp/survey/' + survey_id);
     return this.http.get(environment.api_vi + inst + '/shp/survey/' + survey_id);
  }
  getReferenceSurveyFields(referenceInst, survey_id): Observable<any> {
    //return this.http.get(environment.api_vi + "secureshp/" + referenceInst + '/shp/survey/' + survey_id);
    return this.http.get(environment.api_vi + referenceInst + '/shp/survey/' + survey_id);
  }
 postSurveyFields(data, parature_id,inst): Observable<any> {
    //return this.http.post(environment.api_vi + "secureshp/" + this.institutionId + '/shp/surveyShp/' + parature_id, data);
    return this.http.post(environment.api_vi  + inst + '/shp/surveyShp/' + parature_id, data);
  }
  getDefaultSurveyFields(inst): Observable<any> {
    //return this.http.get(environment.api_vi + "secureshp/" + inst + '/shp/defaultSurvey');
    return this.http.get(environment.api_vi + inst + '/shp/defaultSurvey');
  }
  getCustomSurveyFields(inst): Observable<any> {
   // return this.http.get(environment.api_vi + "secureshp/" + this.institutionId + '/shp/customSurvey');
   return this.http.get(environment.api_vi  + inst + '/shp/customSurvey');
  }
  getAllNotifications(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + '/notification/available');
  }
  getDefaultUser(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.default);
  }
  getChatOfficeTime(): Observable<any> {
    return this.http.get(environment.api_vi + "internal/" + environment.isOfficeTime + "?short_name=" + this.instshortname);
  }
  getChat(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.chatPopUp);
  }
  getPrivacyStatement(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.priavacyStatement);
  }
  getOfficeTime(): Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.officeTime);
  }
  getMessage(): Observable<any> {
    return this.http.get(environment.api_vi + "internal/" + environment.message + "?short_name=" + this.instshortname);
  }
  getContact(): Observable<any> {
    this.userpk = this.authService.getCurrentUserPK();
    return this.http.get(environment.api_vi + "secureshp/" + this.institutionId + environment.contact + this.userpk);
  }

  getFiles(file_id): Observable<any> {
    return this.http.get(environment.api_vi + "secureshp/"+ this.institutionId + "/file/"+ file_id, {responseType: 'blob'} );
  }

  validateSamlAuth(payload): Observable<any> {
    return this.http.post(environment.saml_auth + this.institutionId, payload);
  }

  validateCasAuth(payload): Observable<any> {
    return this.http.post(environment.cas_auth + this.institutionId, payload);
  }

  trackerConfig(): Observable<any> {
    return this.http.get(environment.api_vi + 'secureshp/' + this.institutionId + '/tracker_configuration');
  }

  trackerData():Observable<any> {
    this.userpk = this.authService.getCurrentUserPK();
    return this.http.get(environment.api_vi + 'secureshp/' + this.institutionId + '/integration?caller_id=' + this.userpk)
  }

  trackerPhaseDetail(): Observable<any> {
    return this.http.get(environment.api_vi + 'secureshp/' + this.institutionId + '/trackerIntegrationConfig');
  }

  trackerCase(data): Observable<any> {
    return this.http.post(environment.api_vi + 'secureshp/' + this.institutionId + '/trackerCase' , data);
  }

  navigateToLogin(redirectUrl) {
    console.log("NAVIGATE TO LOGIN CALLED");
    this.loadSpinner.next(true);
    this.getLoginConfig().subscribe(response => {
      let authConfig = response.return_body.authenticationConfig;

      console.log("AUTH CONFIG", authConfig);
      // let samlLoginUrl = response.return_body.loginSamlUrl;
      if (redirectUrl !== undefined && redirectUrl !== null) {
        this.authService.setValueInConfigAtLocalStorage("redirectPostLoginUrl", redirectUrl);
      }

      if (authConfig.loginType === 'SHP DBAuthenticator') {
        this.authService.setValueInConfigAtLocalStorage('allowModifyPwd', 'yes');
      } else {
        this.authService.setValueInConfigAtLocalStorage('allowModifyPwd', 'no');
      }

      if (authConfig.loginType === 'SHP SAML2Authenticator') {
        console.log("Inside SAML AUTH");

        // this.setValueInLocalStorage("isSamlLogin", "true");
        this.authService.setValueInConfigAtLocalStorage('isSamlLogin', 'true');
        this.authService.removeValueInConfigAtLocalStorage('isCasLogin');

        this.authService.login(environment.samlUserName, null, String(this.institutionId), authConfig.loginType)
          .subscribe(data => {
            console.log("POST LOGIN WITH SAML USER:", data);
            if (data.return_body.samlLogoutUrl !== null) {
              // localStorage.setItem('samlLogoutUrl', data.return_body.samlLogoutUrl);
              this.authService.setValueInConfigAtLocalStorage('samlLogoutUrl', data.return_body.samlLogoutUrl);
            }
            window.location.replace(environment.apiBaseURL + '/saml/login/alias/' + this.shortName + '?idp=' + data.return_body.samlLoginUrl);
          });
      } else if (authConfig.loginType === 'SHP CASAuthenticator') {
        console.log("Inside CAS AUTH");
        this.authService.setValueInConfigAtLocalStorage('isCasLogin', 'true');
        this.authService.removeValueInConfigAtLocalStorage('isSamlLogin');
        this.authService.login(environment.casUserName, null, String(this.institutionId), authConfig.loginType)
          .subscribe(data => {
            console.log("POST LOGIN WITH CAS USER:", data);
            if (data.return_body.casLogoutUrl !== null) {
              // localStorage.setItem('samlLogoutUrl', data.return_body.samlLogoutUrl);
              this.authService.setValueInConfigAtLocalStorage('casLogoutUrl', data.return_body.casLogoutUrl);
              this.authService.setValueInConfigAtLocalStorage('casRedirectUrl', data.return_body.casRedirectUrl);
            }
            // window.location.replace(environment.apiBaseURL + '/cas/login/alias/' + this.shortName + '?idp=' + data.return_body.samlLoginUrl);
            window.location.replace(environment.apiBaseURL + '/cas/login/alias/' + this.shortName);
          });

      }
      else {
        console.log("Inside DB AUTH");
        // localStorage.setItem('isSamlLogin', 'false');
        this.authService.setValueInConfigAtLocalStorage('isSamlLogin', 'false');
        this.authService.setValueInConfigAtLocalStorage('isCasLogin', 'false');
        this.router.navigate([this.router.url.split("/")[1], 'login']);
        this.loadSpinner.next(false);
      }
    });
  }
  getCaller(key): Observable<any> {
    this.userpk = this.authService.getCurrentUserPK();
    return this.http.get(environment.api_vi + 'secureshp/' + this.institutionId + '/contact/template/options/' + key);
  }

  getLoginConfig(): Observable<any> {
    return this.http.get(environment.loginConfig + this.institutionId);
  }
  logonBannerConfig():Observable<any> {
    return this.http.get(environment.api_vi + this.institutionId + environment.logonWarning);    
  }

  setValueInLocalStorage(key, value) {
    localStorage.setItem(key, value);
  }

  forceLogout(user): Observable<any> {
    return this.http.delete(environment.api_vi + 'shp/' + user +'/deleteExpiredShpToken')
  }

  checkShpToken(): Observable<any>{
    return this.http.get(environment.api_vi + 'shp/check_shp_token' )
  }

  getPwdPolicies(): Observable<any>{
    return this.http.get(environment.api_vi + 1 + '/pwd/configuration' )
  }
}
